import React from 'react';
import mainBG from '../../../assets/EinführungMainBG.png';
import ellipseBG from '../../../assets/EllipseBG.png';
import { useTranslation } from "react-i18next";
import { getStreamUrl } from "../../../utils/videoUrl";

const PresentationEnd = ({ nextClick, backClick }) => {
    const isSmallScreen = window.innerHeight <= 600;
    const { t } = useTranslation();

    return (
        <div style={{ background: `url(${mainBG})` }} className="h-screen !bg-cover !bg-no-repeat !bg-center flex flex-col justify-end">
            {/* Content Section */}
            <div style={{ background: `url(${ellipseBG})` }} className="min-h-[75vh] !bg-cover !bg-no-repeat !bg-top relative">
                <div className={`relative ${isSmallScreen ? 'pt-12' : 'pt-20'} mx-auto w-full max-w-[36rem] flex flex-col justify-between h-full text-center pb-4 px-6 sm:px-0`}>
                    
                    {/* Title & Description */}
                    <h1 className="font-semibold text-white text-xl">{t(`s-14-title`)}</h1>
                    <h2 className="font-medium text-white text-base mt-4">{t(`s-14-desc`)}</h2>

                    {/* Video Section */}
                    <div className="mt-8">
                        <video className="w-full max-w-[320px] sm:max-w-[400px] mx-auto rounded-lg shadow-lg" controls>
                            <source src={getStreamUrl(t(`video_link_2`))} type="video/mp4" />
                            Your browser does not support the video tag.
                        </video>
                    </div>

                    {/* Buttons */}
                    <div className={`w-full max-w-[32rem] flex gap-6 flex-col-reverse sm:flex-row ${isSmallScreen ? 'pt-2' : 'pt-10'}`}>
                        <button className="w-full button_primary" onClick={backClick}>
                            {t(`s-2-btn1`)}
                        </button>
                        <button className="w-full button_secodry" onClick={nextClick}>
                            {t(`s-2-btn2`)}
                        </button>
                    </div>

                </div>
            </div>
        </div>
    );
};

export default PresentationEnd;
